import React from 'react';
import AutosizeInput from 'react-input-autosize';

export default ({
  text,
  className,
  onClick,
  onEdit,
  onKeyUp,
  DOMRef,
  tabDisabled,
}) => (
  <div className={`quick-reply ${className}`} onClick={onClick}>
    <span className="quick-reply-text">
      <AutosizeInput
        inputRef={DOMRef}
        readOnly={onClick}
        value={text}
        onChange={e => onEdit && onEdit(e.target.value)}
        onKeyUp={e => (text && onKeyUp ? onKeyUp(e) : null)}
        onBlur={e => (text.length < 1 && onEdit ? onEdit('') : null)}
        style={{ fontSize: 16 }}
        placeholder="Write here..."
        tabIndex={tabDisabled ? '-1' : undefined}
      />
    </span>
  </div>
);
